import React from 'react';
import { Button, CircularProgress } from '@mui/material';
import { PaperWrapper, SchoolSelectField } from '../styled';
import CustomMenuItem from '../../../components/CustomMenuItem/CustomMenuItem';
import { School } from '../../SchoolManagement/types/school';
import { SchoolFilterBarProps } from '../types';
import Icons from '../../../components/icons';

const SchoolFilterBar: React.FC<SchoolFilterBarProps> = ({
  schools,
  selectedSchool,
  onSelectedSchoolChange,
  onSearch,
  isSearching
}) => {
  const handleSelectChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    onSelectedSchoolChange(e.target.value);
  };

  const searchDisabled = !selectedSchool || isSearching;

  return (
    <PaperWrapper>
      <SchoolSelectField
        select
        label='Select School'
        value={selectedSchool}
        onChange={handleSelectChange}
        size='small'
      >
        {schools.map((school: School) => (
          <CustomMenuItem key={school.id} value={school.shortCode}>
            {school.displayCode || school.shortCode}
          </CustomMenuItem>
        ))}
      </SchoolSelectField>
      <Button variant='contained' onClick={onSearch} disabled={searchDisabled}>
        <Icons.SearchWhiteOutlined style={{ marginRight: '6px' }} />
        {isSearching ? (
          <CircularProgress size={20} color='inherit' />
        ) : (
          'Search'
        )}
      </Button>
    </PaperWrapper>
  );
};

export default SchoolFilterBar;
